export default __webpack_public_path__ + "static/media/KZ.T.01.0509 black.ee79cbb4.svg";